import {useCallback, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import classes from './StepsAsymmetry.module.scss';
import {PeriodToggle} from '../ClickingOverview/components/PeriodToggle/PeriodToggle';
import {format} from 'date-fns';
import {GET_PATIENT_WALKING_ASYMMETRY_REQUEST} from '../../../../../redux/actions';
import {AsymmetryGraph} from './components';

export const StepsAsymmetry = ({
  patientId,
}: {
  patientId: string;
}) => {
  const dispatch = useDispatch();
  const [dates, setDates] = useState<null | {start: Date, end: Date}>(null);

  const getPatientAsymmetry = useCallback(() => {
    dispatch({
      type: GET_PATIENT_WALKING_ASYMMETRY_REQUEST,
      payload: {
        patientId,
        startDate: format(dates?.start ?? new Date(), 'yyyy-MM-dd'),
        endDate: format(dates?.end ?? new Date(), 'yyyy-MM-dd'),
      }
    })
  }, [dispatch, patientId, dates]);

  useEffect(() => {
    getPatientAsymmetry();
  }, [getPatientAsymmetry])

  return (
    <div className={classes.clickingOverviewContainer}>
      <div className={classes.chartHeader}>
        <PeriodToggle setDates={setDates} />
      </div>
      <AsymmetryGraph />
    </div>
  );
};
